export const state = () => ({
    images: [],
});

export const mutations = {
    addMedia(state, image) {
        state.images.push(image);
    },
    removeMedia(state, image) {
        state.images = state.images.filter((e) => e.id != image);
    },
};

export const getters = {
    getMedia(state) {
        return state.images;
    },
};
